import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { products, ProductVariant } from '../data/products';
import productDetails, { defaultProductDetail } from '../data/productDetails';
import { useCart } from '../context/CartContext';
import ProductGallery from '../components/product/ProductGallery';
import ProductInfo from '../components/product/ProductInfo';
import './ProductPage.css';

interface ProductPageProps {
  category: 'fragrance' | 'body';
}

const ProductPage: React.FC<ProductPageProps> = ({ category }) => {
  const { handle } = useParams<{ handle: string }>();
  const { addItem } = useCart();

  const product = products.find((p) => p.handle === handle && p.category === category);
  if (!product) return <Navigate to={`/${category}`} replace />;

  const detail = productDetails[product.handle] ?? defaultProductDetail;

  const handleAddToCart = (quantity: number, variant: ProductVariant) => {
    addItem(
      {
        productId: product.id,
        handle: product.handle,
        title: product.title,
        variantLabel: variant.label,
        variantValue: variant.value,
        stripePriceId: variant.stripePriceId,
        priceCents: variant.priceCents,
        priceDisplay: variant.priceDisplay,
        image: product.images[0],
      },
      quantity
    );
  };

  return (
    <div className="product-page">
      <nav className="product-page__breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span aria-hidden="true"> / </span>
        <Link to={`/${category}`}>{category.charAt(0).toUpperCase() + category.slice(1)}</Link>
        <span aria-hidden="true"> / </span>
        <span>{product.title}</span>
      </nav>

      <div className="product-page__layout">
        <div className="product-page__gallery-col">
          <ProductGallery images={product.images} title={product.title} />
        </div>
        <div className="product-page__info-col">
          <ProductInfo
            title={product.title}
            description={product.subtitle}
            type={product.type}
            variants={product.variants}
            notes={detail.notes}
            scentProfile={detail.scentProfile}
            scent={detail.scent}
            texture={detail.texture}
            badges={detail.badges}
            accordionItems={detail.accordionItems}
            onAddToCart={handleAddToCart}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductPage;
